// #FF4A4A

const ThemeController = cc.Class({
    extends: cc.Component,

    statics: {
        THEME_COLOR_MAIN: cc.Color,
        THEME_COLOR_LABEL: cc.Color,
        THEME_COLOR_BG: cc.Color,

        THEME_FONT_LIGHT: cc.Font,
        THEME_FONT_MEDIUM: cc.Font,

        THEME_FONT_SIZE_SMALL: 60,
        THEME_FONT_SIZE_MEDIUM: 75,
        THEME_FONT_SIZE_BIG: 90,

        getColor: function(type) {
            switch(type) {
                case 1:
                    return ThemeController.THEME_COLOR_MAIN;
                case 2:
                    return ThemeController.THEME_COLOR_LABEL;
                case 3:
                    return ThemeController.THEME_COLOR_BG;

            }
        }
    },

    properties: {
        refresh: {
            default: false,
            notify: function() {
                this.save();

                this.editorSave();
            }
        },
        themeMainColor: {
            type: cc.Color,
            default: cc.Color.WHITE,
            notify: function() {
                ThemeController.THEME_COLOR_MAIN = this.themeMainColor;
            }
        },
        themeLabelColor: {
            type: cc.Color,
            default: cc.Color.WHITE,
            notify: function() {
                ThemeController.THEME_COLOR_LABEL = this.themeLabelColor;
            }
        },
        themeBgColor: {
            type: cc.Color,
            default: cc.Color.WHITE,
            notify: function() {
                ThemeController.THEME_COLOR_BG = this.themeBgColor;
            }
        },
        themFontLight: {
            type: cc.Font,
            default: null,
            notify: function() {
                ThemeController.THEME_FONT_LIGHT = this.themFontLight;
            }
        },
        themFontMedium: {
            type: cc.Font,
            default: null,
            notify: function() {
                ThemeController.THEME_FONT_MEDIUM = this.themFontMedium;
            }
        },
        themFontSizeSmall: {
            default: 60,
            notify: function() {
                ThemeController.THEME_FONT_SIZE_SMALL = this.themFontSizeSmall;
            }
        },
        themFontSizeMedium: {
            default: 60,
            notify: function() {
                ThemeController.THEME_FONT_SIZE_MEDIUM = this.themFontSizeMedium;
            }
        },
        themFontSizeBig: {
            default: 60,
            notify: function() {
                ThemeController.THEME_FONT_SIZE_BIG = this.themFontSizeBig;
            }
        },
    },

    editorSave() {
        if (!CC_EDITOR) {
            return;
        }

        const GameUI = cc.find('PSUIInitializer/PSUI/GameUI');

        const themItems = GameUI.getComponentsInChildren('ThemeItem');
        themItems.forEach(item => item.themeUpdate());

        const themeLabels = GameUI.getComponentsInChildren('ThemeLabel');
        themeLabels.forEach(item => item.themeUpdate());
        cc.log('finished');
    },


    save () {
        ThemeController.THEME_COLOR_MAIN = this.themeMainColor;
        ThemeController.THEME_COLOR_LABEL = this.themeLabelColor;
        ThemeController.THEME_COLOR_BG = this.themeBgColor;

        ThemeController.THEME_FONT_MEDIUM = this.themFontMedium;
        ThemeController.THEME_FONT_LIGHT = this.themFontLight;

        ThemeController.THEME_FONT_SIZE_SMALL = this.themFontSizeSmall;
        ThemeController.THEME_FONT_SIZE_MEDIUM = this.themFontSizeMedium;
        ThemeController.THEME_FONT_SIZE_BIG = this.themFontSizeBig;
    },

    onLoad () {
        const themeCustomColors = cc.find('ThemeColors');

        if (themeCustomColors) {
            const mainColor = themeCustomColors.getChildByName('mainColor');
            const labelColor = themeCustomColors.getChildByName('labelColor');
            const bgColor = themeCustomColors.getChildByName('bgColor');

            if (mainColor) {
                this.themeMainColor = mainColor.color.clone();
                this.themeMainColor.a = mainColor.opacity;
            }
            if (labelColor) {
                this.themeLabelColor = labelColor.color.clone();
                this.themeLabelColor.a = labelColor.opacity;
            }
            if (bgColor) {
                this.themeBgColor = bgColor.color.clone();
                this.themeBgColor.a = bgColor.opacity;
            }
        }
        this.save();

        this.items = [];
    },

    register (themeItem) {
        this.items.push(themeItem);
        themeItem.themeUpdate();
    }
});
